import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getDevicesRequest } from "lib/api/reference/device";
import type { DeviceInterface } from "types/reference";

export const deviceReferenceKeys = {
    all: ["reference", "device"] as const,
    list: (languageCode: string) => [...deviceReferenceKeys.all, "list", languageCode] as const,
};

export const fetchDevices = (languageCode: string) =>
    parseResponse<Array<DeviceInterface>>(getDevicesRequest(languageCode));

export const deviceReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<DeviceInterface>>({
        queryKey: deviceReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchDevices(languageCode),
        enabled: Boolean(languageCode),
    });

export const useDevices = (languageCode: string) => useQuery(deviceReferenceQueryOptions(languageCode));
